import JourneyCard from "./card/journeyCard";
import "./journey.css";
import GASOLINEIMG from "../../../assets/png/1000_EFI _GASOLINE.png";
import TU01 from "../../../assets/png/TU01.png";
import TUSC01 from "../../../assets/png/TUSC01.png";
import { RouterPaths } from "../../../router/router";

const Journey = ({ title }) => {
  const JourneyList = [
    {
      title: "GASOLINE",
      subTitle: "1000EFI MODEL",
      img: GASOLINEIMG,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.EFI,
    },
    {
      title: "ELECTRIC",
      subTitle: "1500E MODELS",
      img: TU01,
      Capacity: "2WD / 4WD",
      Models: 3,
      link: RouterPaths.TU1500E2,
    },
    {
      title: "ELECTRIC DUAL MOTOR",
      subTitle: "2500E MODELS",
      img: TUSC01,
      Capacity: "2WD / 4WD",
      Models: 2,
      link: RouterPaths.TUDC2500E1,
    },
  ];
  return (
    <>
      <div className="font-[Rockwell] 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px] font-extrabold text-center">
        {title}
      </div>{" "}
      <div className=" 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] font-normal text-center">
        Narrow down our lineup of models and compare up to 3 vehicles at a time.
      </div>
      <div className="flex items-center justify-center mb-[90px] mt-[35px]">
        <div className="bg-[#7ABF5B] sm:h-[5px] h-[4px] sm:w-[350px] w-[150px]"></div>
      </div>
      <div class="grid 2xl:grid-cols-3 xl:grid-cols-2 md:grid-cols-1 grid-cols-1 gap-8">
        {JourneyList?.map((item) => {
          return <JourneyCard item={item} />;
        })}
      </div>
    </>
  );
};
export default Journey;
